import { c as _c } from "react/compiler-runtime";
import { Suspense, useLayoutEffect, useRef, type ReactNode } from "react";
import { SidebarInset } from "@repo/blacksmith-ui/sidebar";
import { cn } from "@repo/blacksmith-ui/cn";

/**
 * The main pane and its Suspense boundary stay mounted across route changes.
 * React only holds the current page through a transition when the boundary
 * that would catch the next page's suspension is already on screen; a
 * remounted boundary shows its fallback the moment the route commits, so
 * every route change flashed a blank pane before the next page appeared.
 */
export function SidebarMainContent(t0) {
  const $ = _c(11);
  const {
    children,
    fixedMain,
    scrollResetKey,
    fallback
  } = t0;
  const mainRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const main = mainRef.current;
      if (!main) {
        return;
      }
      main.scrollTop = 0;
      main.scrollLeft = 0;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== scrollResetKey) {
    t2 = [scrollResetKey];
    $[1] = scrollResetKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  const t3 = fixedMain ? "min-h-0 overflow-hidden" : "overflow-y-auto [scrollbar-gutter:stable]";
  let t4;
  if ($[3] !== t3) {
    t4 = cn("flex-1 bg-transparent!", t3);
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== fallback) {
    t5 = <Suspense fallback={fallback}>{children}</Suspense>;
    $[5] = children;
    $[6] = fallback;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <SidebarInset ref={mainRef} className={t4}>{t5}</SidebarInset>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}